import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getContents } from "../../actions/contents";
import { convertToSlug, limitCharacters } from "../../helpers/common";
import moment from "moment";
import SmallLoader from "../../helpers/Common/SmallLoader";
import AOS from "aos";
import "aos/dist/aos.css";
import Cta from "../Company/AboutUs/Cta";
const BlogContent = () => {
  const contents = useSelector((state) => state.contents);

  // API Response Handling: data array nikalna
  const rawBlogs = contents["blogs"];
  const blogs = Array.isArray(rawBlogs)
    ? rawBlogs
    : rawBlogs?.data || rawBlogs?.result || [];

  const loading = contents.loading;
  const dispatch = useDispatch();
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
  useEffect(() => {
    dispatch(getContents("blogs"));
  }, [dispatch]);

  if (loading) {
    return <SmallLoader />;
  }

  return (
    <React.Fragment>
      <section className="section  bg-opacity-50">
        <Container>
          {/* New Attractive Heading Section */}
          <Row className="justify-content-center">
            <Col lg={7}>
              <div
                className="section-title text-center mb-5"
                data-aos="fade-up"
              >
                <h6 className="text-primary text-uppercase fw-bold ls-1 mb-2">
                  Our Journal
                </h6>
                <h3 className="title mb-3 fw-bold">
                  Latest Insights &{" "}
                  <span className="text-primary">Hospitality Trends</span>
                </h3>
                <p className="text-muted mx-auto" style={{ maxWidth: "600px" }}>
                  Stay updated with the latest openings, career advice, and
                  industry trends curated by the Webvi Hospitality expert team.
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            {blogs.length > 0 ? (
              blogs.map((blog, index) => (
                <Col
                  lg={6}
                  key={`blog-${blog?.id}`}
                  className="mb-4"
                  // AOS staggered entrance
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <article
                    className="post card border-0 shadow-sm overflow-hidden h-100 transition-up"
                    style={{ borderRadius: "15px" }}
                  >
                    {/* Image Container */}
                    <div className="post-preview overflow-hidden position-relative">
                      <Link
                        to={`/blogs/${blog?.id}/${convertToSlug(blog?.name)}`}
                      >
                        <img
                          src={blog?.image}
                          alt={blog?.name}
                          className="img-fluid blog-img-hover"
                          style={{
                            width: "100%",
                            height: "280px",
                            objectFit: "cover",
                            transition: "transform 0.5s",
                          }}
                        />
                      </Link>
                    </div>

                    {/* Content Body */}
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-2">
                        <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 rounded-pill small">
                          <i className="uil uil-calendar-alt me-1"></i>
                          {moment(blog?.createdAt).format("MMM DD, YYYY")}
                        </span>
                      </div>

                      <h5 className="mb-3 mt-2">
                        <Link
                          to={`/blogs/${blog?.id}/${convertToSlug(blog?.name)}`}
                          className="text-dark fw-bold text-decoration-none"
                          style={{ lineHeight: "1.4", display: "block" }}
                        >
                          {blog?.name}
                        </Link>
                      </h5>

                      <div
                        className="text-muted"
                        style={{
                          fontSize: "14.5px",
                          height: "65px",
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                        }}
                        dangerouslySetInnerHTML={{
                          __html:
                            blog?.shortDescription ||
                            "<p>No description available.</p>",
                        }}
                      />

                      <div className="pt-3 border-top mt-3 d-flex justify-content-between align-items-center">
                        <Link
                          to={`/blogs/${blog?.id}/${convertToSlug(blog?.name)}`}
                          className="text-primary fw-bold text-decoration-none small text-uppercase"
                          style={{ letterSpacing: "1px" }}
                        >
                          Read Full Blog{" "}
                          <i className="uil uil-arrow-right align-middle ms-1"></i>
                        </Link>
                      </div>
                    </div>
                  </article>
                </Col>
              ))
            ) : (
              <div className="text-center mt-5 py-5 w-100">
                <div
                  className="spinner-border text-primary mb-3"
                  role="status"
                ></div>
                <h4 className="text-muted">Discovering stories for you...</h4>
              </div>
            )}
          </Row>

          {/* CSS for better UI enhancements */}
          <style>{`
          .ls-1 { letter-spacing: 1px; }
          .transition-up {
            transition: all 0.3s ease-in-out;
          }
          .transition-up:hover {
            transform: translateY(-10px);
            box-shadow: 0 15px 35px rgba(0,0,0,0.12) !important;
          }
          .post-preview:hover .blog-img-hover {
            transform: scale(1.05);
          }
          .bg-primary-subtle {
            background-color: #eef2ff !important;
          }
          .text-primary {
            color: #387ed8 !important;
          }
        `}</style>
        </Container>
      </section>
      <Cta />
    </React.Fragment>
  );
};

export default BlogContent;
